"use server";

import { classwiseLocationsService, type ClasswiseLocation } from "../services/classwiseLocationsService";
import { extractDomain } from "../utils/domain";

export interface LocationsActionResponse {
  success: boolean;
  data: ClasswiseLocation[];
  message?: string;
}

export async function fetchLocationsAction(accountId?: string): Promise<LocationsActionResponse> {
  try {
    const domain = await extractDomain();
    let resolvedAccountId = accountId;

    if (domain === "web.youngengineers.org" || domain === "preview.youngengineers.org") {
      resolvedAccountId = process.env.NEXT_PUBLIC_CLASSWISE_GLOBAL_ACCOUNT_ID || "1162885000381811255";
    }

    // Every other domain passes whatever the API reported for that tenant —
    // which may be nothing. That is deliberate, not a gap: CLASSWISE_TOKEN is
    // per-deployment and Classwise scopes the response to the token's own
    // account when `account_id` is absent. Verified against get-POS-list: with
    // no account_id it returns this franchise's own location, the same one the
    // old env fallback happened to return, while the *global* id returns a
    // different franchise's. Sending nothing is therefore both correct and
    // safer than guessing — and it is exactly what fetchClassesAction already
    // does, which is why the class listing works for franchises with no
    // zoho_franchise_id.
    const locations = await classwiseLocationsService.fetchLocations(resolvedAccountId);

    if (locations.length === 0) {
      return {
        success: false,
        data: [],
        message: "No locations found",
      };
    }


    return {
      success: true,
      data: locations,
      message: "Locations fetched successfully",
    };
  } catch (error) {
    console.error("[fetchLocationsAction] Error:", error);
    return {
      success: false,
      data: [],
      message: error instanceof Error ? error.message : "Failed to fetch locations",
    };
  }
}
